import { render } from "./SetupConfiguration.vue?vue&type=template&id=3bc7fef7"
import script from "./SetupConfiguration.vue?vue&type=script&lang=js"
export * from "./SetupConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__